import { Table, Typography } from "antd"
import { useTranslation } from "react-i18next"

import styles from "./summaryRows.module.less"

const { Text } = Typography

// The Summary / Compare rows Health's breakdown tables end with, for the Recover tables.
// `cells` follows the table's columns after the first: `{ render(summary), align }`, or null where
// the summary has nothing to say. The Compare row is there only while a comparison is on.
const SummaryRows = ({ summary, comparisonSummary, comparisonLabel, cells }) => {
  const { t } = useTranslation()

  if (!summary) return null

  const row = (label, data) => (
    <Table.Summary.Row className={styles.row}>
      <Table.Summary.Cell index={0}>
        <Text type="secondary" strong>
          {label}
        </Text>
      </Table.Summary.Cell>
      {cells.map((cell, index) => (
        <Table.Summary.Cell key={index} index={index + 1} align={cell?.align}>
          {cell ? <Text strong>{cell.render(data)}</Text> : null}
        </Table.Summary.Cell>
      ))}
    </Table.Summary.Row>
  )

  return (
    <>
      {row(t("Summary"), summary)}
      {comparisonSummary
        ? row(`${t("Compare")} ${comparisonLabel || t("previous period")}`, comparisonSummary)
        : null}
    </>
  )
}

export default SummaryRows
